import {Directive, HostListener} from '@angular/core';

import * as screenfull from 'screenfull';

@Directive({
  selector: '[appToggleFullScreen]'
})
export class ToggleFullScreenDirective {

  @HostListener('click')
  onClick() {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/fullscreen/toggle-fullscreen.directive.ts